/** Public marketing and account routes. These do not wait on a surface snapshot. */

export const LANDING_PATH = '/';
export const SIGN_IN_PATH = '/signin';
export const SIGN_UP_PATH = '/signup';
export const FORGOT_PATH = '/forgot';
export const RESET_PATH = '/reset';
export const VERIFY_PATH = '/verify';

export const PUBLIC_PATHS = [
  LANDING_PATH,
  SIGN_IN_PATH,
  SIGN_UP_PATH,
  FORGOT_PATH,
  RESET_PATH,
  VERIFY_PATH,
] as const;

/** Pages that spend a one-time link on arrival. */
export const SPENDS_LINK: ReadonlySet<string> = new Set([VERIFY_PATH]);

export function isAccountPath(path: string): boolean {
  return path !== LANDING_PATH && isPublicPath(path);
}

export type PublicPath = (typeof PUBLIC_PATHS)[number];

export function isPublicPath(path: string): path is PublicPath {
  return (PUBLIC_PATHS as readonly string[]).includes(path);
}
